import { Moment } from 'moment'

import React from 'react'

import styled from 'styled-components'

import { Panel } from 'components/Panel'

import ActiveAlerts from 'pages/Device/AlertsPanel/ActiveAlerts'
import AlertsHistory from 'pages/Device/AlertsPanel/AlertsHistory'
import HomeownerPanelHeaderNotification from 'pages/shared/HomeownerAlert/HomeownerPanelHeaderNotification'
import LastUpdated from 'pages/Device/LastUpdated'

import useNexiaStream from 'hooks/useNexiaStream'

import { highestSeverity, updateAlertsSeverity } from 'helpers/alerts'

import { screenSize, NoData, screenWidthBreakpoints, alertsAndRthPanelLongVersionTitleWidth } from 'styles/shared'
import { color } from 'styles/colors'

export type Props = {
  dealerId: number
  deviceId: string
  deviceTimeZone: string
  reportCache: object
  showDayRthCallback: (day: Moment) => void
}

const AlertsPanel = ({ dealerId, deviceId, deviceTimeZone, reportCache, showDayRthCallback }: Props) => {
  const { eventData: report } = useNexiaStream(deviceId, 'alarms', reportCache)

  const severity = highestSeverity(updateAlertsSeverity(report?.alerts || []))
  return (
    <S.Panel pingdomId="alerts-container" id="alerts" scrollToSection>
      <S.Header>
        <S.PanelTitle severity={severity}>Alerts {report?.alerts?.length > 0 ? `(${report?.alerts?.length})` : ''}</S.PanelTitle>
        <HomeownerPanelHeaderNotification />
        <S.LastUpdatedArea>{report && <LastUpdated date={report?.lastUpdatedAt} /> }</S.LastUpdatedArea>
      </S.Header>
      {
        !report
          ? <S.NoData><h1>No Data Received Yet</h1></S.NoData>
          : (
            <>
              <ActiveAlerts alerts={report.alerts || []} showDayRthCallback={showDayRthCallback} />
              <AlertsHistory deviceId={deviceId} dealerId={dealerId} deviceTimeZone={deviceTimeZone} showDayRthCallback={showDayRthCallback} />
            </>
          )
      }
    </S.Panel>
  )
}

export default AlertsPanel

const S = {
  Panel: styled(Panel) <{ id: string }>`
    scroll-margin-top: 60px;
    @media ${screenSize.small} {
      overflow: unset;
    }
  `,
  Header: styled(Panel.Header)`
    padding-right: 0px;
    flex: 1;
  `,
  PanelTitle: styled(Panel.Title).withConfig({
    shouldForwardProp: (prop) => !['severity'].includes(prop)
  }) <{ severity: string | null }>`
    width: max-content;
    ${({ severity }) => severity ? `border-bottom:3px solid ${color(`${severity}Alert`)}` : 'none'}
  `,
  LastUpdatedArea: styled.div`
    @media (min-width: ${screenWidthBreakpoints.devicePanelHeaderShortVersionBreakpoint}px) {
      width: ${alertsAndRthPanelLongVersionTitleWidth}px;
    }
  `,
  NoData: styled(NoData)`
    h1 {
      font-size: 24px;
    }
  `
}
